export {};
//# sourceMappingURL=AuthSession.types.js.map